import React from 'react';
import { useLanguage } from "../../../hooks/Language";
import { Children } from "react";
import { ParagraphUI } from "./styles";

interface IProps {
    children?: React.ReactNode;
    style?: Record<string, any>;
    theme?: 'dark' | 'light';
    className?: string;
}

const Paragraph: React.FC<IProps> = ({ children, style, theme, className }) => {
    const { translate } = useLanguage();

    return <ParagraphUI className={className} themeValue={theme} style={style}>{translate(children)}</ParagraphUI>;
}

export default Paragraph;